export default __webpack_public_path__ + "static/media/clock-image.7acc2a43.png";